// extracted by mini-css-extract-plugin
module.exports = {"alert":"snackbar_alert__4x9Ae","alert-success":"snackbar_alert-success__x4m14","alert-error":"snackbar_alert-error__CPsEC","alert-warning":"snackbar_alert-warning__2iXAm"};